import { buildParams } from "/app/src/helpers";
import { useQuery } from "@tanstack/react-query";
import { statusService } from "/app/src/services";
import DraggableStatusArea from "./draggableStatusArea";
import NewStatus from "./newStatus";
import Box from "/app/src/components/generic/components/box";
import { Integration } from "/app/src/models";

/**
 * Component for managing the custom statuses in Order Builder
 */
export default function OrderBuilderStatuses({
  integration,
}: {
  integration: Integration;
}) {
  const { data: customStatuses } = useQuery({
    queryKey: ["statuses", "custom", integration.id],
    queryFn: () =>
      statusService
        .getAll(
          buildParams({
            integrationId: integration.id,
          }),
        )
        .then((response) => {
          return {
            statuses: response.statuses.filter(
              (status) => status.name !== "Error",
            ),
          };
        }),
    initialData: { statuses: [] },
    select: (data) => data.statuses,
  });

  return (
    <Box>
      <h2>Order Builder - Custom Statuses</h2>
      <DraggableStatusArea
        integration={integration}
        statuses={customStatuses}
      />
      <div className="newReportColumn">
        <NewStatus integration={integration} />
      </div>
    </Box>
  );
}
